import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base/base.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

type urlFunc = (input: any) => string;

type onResponseAll = () => void;
type onResponseSucesso = (input: any) => void;
type onResponseErro = (input: any) => void;

type onResponseFile = (file: downloadedFile) => void;

export interface downloadedFile {
  blob: Blob,
  filename: string,
  type: string
}

export function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  let bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export const montarQueryString = <T>(obj: T) => {
  const filtro = Object.entries(obj).filter(([k, v]) => v && !Array.isArray(v));
  Object.entries(obj).filter(([k, v]) => v && Array.isArray(v)).forEach(e => {
    for (let index = 0; index < e[1].length; index++) {
      filtro.push([e[0], e[1][index]]);
    }
  });
  return new URLSearchParams(filtro);
};

@Injectable({
  providedIn: 'root'
})

export abstract class BaseCrudService
  extends BaseService {

  abstract consultarUrl: urlFunc;
  abstract atualizarUrl: urlFunc;
  abstract cadastrarUrl: urlFunc;
  abstract excelUrl: urlFunc;

  constructor(public override http: HttpClient) {
    super(http);
  }

  public consultar<R>(input: any): Observable<R> {
    return this.get(`${this.consultarUrl(input)}`, this.apiController);
  };

  public consultarPorId<R>(id: number, pk_name: string = "id"): Observable<R> {
    let filter = {};
    filter[pk_name] = id;
    return this.consultar(filter);
  };

  public atualizar<R>(input: any): Observable<HttpResponse<R>> {
    return this.put(`${this.atualizarUrl(input)}`, input, this.apiController);
  };

  public cadastrar<R>(input: any): Observable<HttpResponse<R>> {
    return this.post(`${this.cadastrarUrl(input)}`, input, this.apiController);
  };

  public excel(input: any,
    success: onResponseFile,
    error: onResponseErro = (err) => console.error("erro", err)) {
    return this.download(`${this.excelUrl(input)}`, success, error);
  };

  public excelByUrl(url : string,
    success: onResponseFile,
    error: onResponseErro = (err) => console.error("erro", err)) {
    return this.download(`${url}`, success, error);
  };


}